export default {
    no: require('./locale.no.js').default
};



/** WEBPACK FOOTER **
 ** ../src/widgets/i18/moment/locale.all.js
 **/